import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';
import LocalizedMessage from '../common/LocalizedMessage';

const roleLabels = {
  CLIENT: ['Konto klienta', 'auth:context.client'],
  TEACHER: ['Konto nauczyciela', 'auth:context.teacher'],
  ADMIN: ['Panel administratora', 'auth:context.admin'],
  OPERATOR: ['Panel operatora', 'auth:context.operator'],
};

function contextLabel(context, tr) {
  const role = roleLabels[context.role];
  if (!role) return context.label;
  const [prefix, key] = role;
  // Translate only the generated role prefix; school names and custom labels belong to users.
  if (context.label === prefix || context.label.startsWith(`${prefix} - `)) {
    return `${tr(key)}${context.label.slice(prefix.length)}`;
  }
  return context.label;
}

function ContextChoice({
  contexts,
  onSelect,
  disabled,
  error,
  onCancel,
  cancelLabel,
}) {
  const { t: tr } = useTranslation();
  return (
    <div className="quiz-text">
      {error && (
        <div role="alert" className="alert alert-danger">
          <LocalizedMessage isError value={error} />
        </div>
      )}
      <h2><strong>{tr("auth:chooseAccount")}</strong></h2>
      <div className="row">
        {contexts.map(context => (
          <div className="col-md-4 mb-2" key={context.contextKey}>
            <button
              type="button"
              data-context-key={context.contextKey}
              className="btn manage-button manage-red-button btn-block"
              disabled={disabled}
              onClick={() => onSelect(context)}
            >
              {contextLabel(context, tr)}
            </button>
          </div>
        ))}
      </div>
      {onCancel && (
        <button
          type="button"
          className="btn manage-button manage-teal-button mt-2"
          disabled={disabled}
          onClick={onCancel}
        >
          <LocalizedMessage value={cancelLabel} />
        </button>
      )}
    </div>
  );
}

ContextChoice.propTypes = {
  contexts: PropTypes.arrayOf(PropTypes.shape({
    contextKey: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    schoolId: PropTypes.string,
  })).isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  onCancel: PropTypes.func,
  cancelLabel: PropTypes.string,
};

ContextChoice.defaultProps = {
  disabled: false,
  error: "",
  onCancel: null,
  cancelLabel: "Anuluj",
};

export default ContextChoice;
